<template>
  <div class="videos-report">
    <div class="videos-report-header">AI视频报道</div>
  </div>
</template>

<script>
export default {
  name: 'paperAiVideos',
  data() {
    return {}
  },
  components: {},
  mounted() {
    this.$store.dispatch('common/login')
  }
}
</script>
<style lang="scss">
.videos-report {
  width: 100%;
  height: 100%;
  padding-left: 18px;
  .videos-report-header {
    font-size: 18px;
  }
}
</style>
